module.exports = {"445102007":"桥东街道","445102008":"城西街道","445102009":"凤新街道","445102010":"太平街道","445102011":"西新街道","445102100":"意溪镇","445102111":"磷溪镇","445102112":"铁铺镇","445102113":"官塘镇","445102400":"红山林场","445102401":"开发区","445102402":"潮州市凤泉湖高新技术产业开发区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/445102.json
// module id = 2182
// module chunks = 0